module.exports = __webpack_public_path__ + "static/media/coin6.0bf096c1.webp";